import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import useSearchAutoComplete, {
  SEARCH_ITEM_TYPES,
} from "../../../query/useSearchAutoComplete";

import "./SearchMultiList.scss";
import "../searchBrandList/SearchBrandList.scss";
import { useSearchInputStore } from "../../../store/useSearchInputStore";
import BrandListItem from "../searchBrandList/BrandListItem";
import SearchRecommendationItem from "./SearchRecommendationItem";
import SearchBrandMoreButton from "./SearchBrandMoreButton";

/**
 * 브랜드 + 키워드 리스트
 * @param hostname
 * @param userAgent
 * @param handleOnBrandClick
 * @param handleOnQueryClick
 * @returns {React.JSX.Element|null}
 * @constructor
 */
export default function SearchMultiList({
  hostname,
  userAgent,
  handleOnBrandClick,
  handleOnQueryClick,
}) {
  const { searchQuery } = useSearchInputStore();
  const [listData, setListData] = useState(null);
  const { data, insertMoreBrands, loading, error } =
    useSearchAutoComplete(searchQuery);

  const handleMoreClick = useCallback(() => {
    const newData = insertMoreBrands();
    setListData(newData);
  }, [insertMoreBrands]);

  useEffect(() => {
    if (data !== null) {
      setListData(data);
    }
  }, [data]);

  const renderItem = useCallback(
    (item) => {
      switch (item.type) {
        case SEARCH_ITEM_TYPES.HEADER:
          return (
            <div className="search-list-header" key={item.id}>
              {item.data.title}
            </div>
          );
        case SEARCH_ITEM_TYPES.BRAND:
          return (
            <BrandListItem
              key={item.id}
              brand={item.data}
              searchQuery={searchQuery}
              hostname={hostname}
              userAgent={userAgent}
              onClick={handleOnBrandClick}
            />
          );
        case SEARCH_ITEM_TYPES.BRAND_MORE:
          return (
            <SearchBrandMoreButton key={item.id} onClick={handleMoreClick} />
          );
        case SEARCH_ITEM_TYPES.RECOMMENDATION:
          return (
            <SearchRecommendationItem
              key={item.id}
              data={item.data}
              searchQuery={searchQuery}
              onClick={handleOnQueryClick}
            />
          );
        default:
          return null;
      }
    },
    [searchQuery, handleMoreClick, hostname, userAgent],
  );

  if (!searchQuery || error) return null;

  return (
    <div className="SearchMultiList">
      {!loading && listData && listData.length === 0 && searchQuery ? (
        <div className="SearchMultiList-empty">검색 결과 없음</div>
      ) : (
        listData && listData.map(renderItem)
      )}
    </div>
  );
}

SearchMultiList.propTypes = {
  searchQuery: PropTypes.string,
  searchHistory: PropTypes.object,
  submitSearch: PropTypes.func,
  hostname: PropTypes.string,
  userAgent: PropTypes.string,
  handleOnBrandClick: PropTypes.func,
  handleOnQueryClick: PropTypes.func,
};
